// extracted by mini-css-extract-plugin
export default {"root":"AlertsMap_root__AGqBk","mapContainer":"AlertsMap_mapContainer__t-+rB","header":"AlertsMap_header__OFmt2","noAlerts":"AlertsMap_noAlerts__T+Kqt"};